import {
    INFRA_SERVICES,
    PermissionSelectors,
} from 'reactApp/modules/PermissionsModule/PermissionsModule';

const createApp = PermissionSelectors.checkPermissions({
    modify: [
        INFRA_SERVICES.heat,
        INFRA_SERVICES.nova,
        INFRA_SERVICES.cinder,
        INFRA_SERVICES.neutron,
    ],
    view: [INFRA_SERVICES.glance],
});

const deleteApp = PermissionSelectors.checkPermissions({
    del: [
        INFRA_SERVICES.heat,
        INFRA_SERVICES.nova,
        INFRA_SERVICES.cinder,
        INFRA_SERVICES.neutron,
    ],
});

export const AppsPermissionSelector = {
    getPermissions(state) {
        return {
            createApp: createApp(state),
            deleteApp: deleteApp(state),
        };
    },
    createApp,
};
